import React, { useState, useContext } from 'react'
import { useSubscription } from '@apollo/client';
import CommonDiv from 'Components/CommonDiv'
import styled from 'styled-components'
import { THEME } from 'Util/constants'
import { ADMIN_USER_GROUPS, USER_PROFILE_ROLES } from 'Util/subscriptions';
import { notification, Select } from 'antd';
import _ from 'lodash'
import { FaPlusCircle } from 'react-icons/fa';
import { UsersCardContext } from '../../UsersCard';

const Container = styled.div``

function GroupSelect() {

    const { userData, setUserData } = useContext(UsersCardContext)

    const [data, setData] = useState([])
    const [selected, setSelected] = useState(null)
    const { loading } = useSubscription(ADMIN_USER_GROUPS, {
        onSubscriptionData({ subscriptionData: { data } }) {
            data.user_groups && setData(data.user_groups.map(ug => ({
                id: ug.id,
                key: `user-groups-data-${ug.id}`,
                code: ug.code ?? '',
                name: ug.name ?? '',
                profile: ug.user_role.profile_id ?? '',
                data: ug
            })))
        }
    });

    const selectHandler = (id) => {
        setSelected(_.find(data, { id }))
    }

    const addHandler = () => {
        if (selected) {
            const { admin_user_groups } = userData

            if (!admin_user_groups.map(aug => (aug.user_group.id)).includes(selected.id)) {
                setUserData({
                    ...userData, admin_user_groups: [
                        ...admin_user_groups,
                        { user_group: selected.data }
                    ]
                })
            } else {
                notification.error({
                    message: 'User group already been selected.'
                })

            }

        }
    }

    return (
        <Container>
            <CommonDiv direction="row" align="center" >
                <Select style={{ width: '100%', marginRight: 15 }} onSelect={selectHandler} >
                    {
                        data.map(ug =>
                            <Select.Option key={ug.key} value={ug.id} >
                                <CommonDiv direction="row" align="center" >
                                    <label style={{ minWidth: 180, color: `${THEME.colors.primary}` }} >{ug.code}</label>
                                    <label>{ug.name}</label>
                                </CommonDiv>
                            </Select.Option>
                        )
                    }
                </Select>
                <FaPlusCircle onClick={addHandler} cursor="pointer" size={25} color={THEME.colors.primary} />
            </CommonDiv>

        </Container>
    )
}

export default GroupSelect